"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  SMALL: 'small',
  MEDIUM: 'medium',
  STANDARD: 'standard',
  LARGE: 'large',
  XLARGE: 'xlarge'
};
exports.default = _default;
//# sourceMappingURL=MessengerSize.js.map